import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import MobileTopBar from './MobileTopBar';
import { useCompactLayout } from '../../Hooks/useCompactLayout';
import { AppContainer, Sidebar as SidebarSpacer, Content } from '../../Styles/AppStyles';

export const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isCompact = useCompactLayout();
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setNavOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!isCompact) setNavOpen(false);
  }, [isCompact]);

  useEffect(() => {
    if (!isCompact || !navOpen) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [isCompact, navOpen]);

  return (
    <AppContainer>
      {isCompact && <MobileTopBar onMenuClick={() => setNavOpen(true)} />}
      {isCompact ? (
        <Sidebar compact open={navOpen} onClose={() => setNavOpen(false)} />
      ) : (
        <SidebarSpacer>
          <Sidebar />
        </SidebarSpacer>
      )}
      <Content $compact={isCompact}>{children}</Content>
    </AppContainer>
  );
};

export default AppLayout;
